import dayjs from 'dayjs';

export const RETAIN_IQ_DATE_FORMAT = 'MM-DD-YYYY';
export const RETAIN_IQ_DATETIME_FORMAT = 'MM-DD-YYYY HH:mm';
export const RETAIN_IQ_STORAGE_DATE_FORMAT = 'YYYY-MM-DD';

export function formatRetainIQDate(value: unknown): string {
  if (value == null || value === '') return '';
  const d = dayjs(String(value));
  return d.isValid() ? d.format(RETAIN_IQ_DATE_FORMAT) : String(value);
}

export function formatRetainIQDateTime(value: unknown): string {
  if (value == null || value === '') return '';
  const d = dayjs(String(value));
  return d.isValid() ? d.format(RETAIN_IQ_DATETIME_FORMAT) : String(value);
}

export function displayRetainIQDate(value: unknown): string {
  return formatRetainIQDate(value) || '—';
}

export function displayRetainIQDateTime(value: unknown): string {
  return formatRetainIQDateTime(value) || '—';
}
